import type { IJobAssociatedMaintenanceTypeUpdate } from '@/interfaces'

class JobAssociatedMaintenanceTypeUpdate implements IJobAssociatedMaintenanceTypeUpdate {
  id: string

  workHours?: number

  constructor(update?: any) {
    this.id = update?.id
    this.workHours = update?.workHours
  }
}

export default JobAssociatedMaintenanceTypeUpdate
